define('MerchandisingZoneSliders', [
    'Merchandising.View',
    'ItemRelations.RelatedItem.View',
    'Configuration',
    'Backbone',
    'underscore',
    'Utils',
    'jQuery'
], function MerchandisingZoneSlider(
    MerchandisingView,
    ItemRelationsRelatedItemView,
    Configuration,
    Backbone,
    _,
    Utils,
    jQuery
) {
    'use strict';

    Configuration = Configuration.Configuration || Configuration;

    var installedKey = 'awaLabsScopedSliderInstalled';
    var sliderInstanceKey = 'awaLabsMerchandisingSliderInstance';
    var sliderElementKey = 'awaLabsMerchandisingSliderElement';
    var originalDestroy = MerchandisingView.prototype.destroy;
    var originalRender = MerchandisingView.prototype.render;

    function initBxSlider($element, options) {
        if ($element.bxSlider && !_.oldIE() && !SC.isPageGenerator()) {
            return $element.bxSlider(options);
        }
        return null;
    }

    function destroySlider(view) {
        var slider = view && view[sliderInstanceKey];

        if (slider && typeof slider.destroySlider === 'function') {
            slider.destroySlider();
        }
        if (view) {
            view[sliderInstanceKey] = null;
            view[sliderElementKey] = null;
            view.$slider = null;
        }
    }

    if (!MerchandisingView.prototype[installedKey]) {
        _.extend(MerchandisingView.prototype, {
            initSlider: function initSlider() {
                var $element = this.$el.find(
                    '.merchandising-zone-row-template[data-type="carousel-items"]'
                );
                var element = $element[0];
                var currentSlider = this[sliderInstanceKey];
                var sliderBaseOptions = {
                    nextText: '<a class="home-slider-next-icon"><\/a>',
                    prevText: '<a class="home-slider-prev-icon"><\/a>',
                    minSlides: 2,
                    maxSlides: 5,
                    slideWidth: 260,
                    forceStart: true,
                    infiniteLoop: true,
                    preloadImages: 'all',
                    slideMargin: 15,
                    shrinkItems: true
                };

                if (!element) {
                    destroySlider(this);
                    return;
                }

                if (currentSlider && this[sliderElementKey] === element) {
                    if (typeof currentSlider.reloadSlider === 'function') {
                        currentSlider.reloadSlider(sliderBaseOptions);
                    }
                    return;
                }

                destroySlider(this);
                this.$slider = $element;
                this[sliderElementKey] = element;
                this[sliderInstanceKey] = initBxSlider($element, sliderBaseOptions);
            },

            render: function renderScopedMerchandisingZone() {
                destroySlider(this);
                return originalRender.apply(this, arguments);
            },

            destroy: function destroyScopedMerchandisingZone() {
                destroySlider(this);
                return originalDestroy.apply(this, arguments);
            }
        });
        MerchandisingView.prototype[installedKey] = true;
    }

});
